var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-divider', _vm._b({}, 'el-divider', _vm.$attrs, false), [_vm.title ? [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })] : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };